import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "qin-sub-header"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "qin-sub-header__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "qin-sub-header__image",
    src: "/static/app/quod-light-logo.svg",
    alt: "qin-logo-image"
  })
], -1)
const _hoisted_3 = { class: "qin-sub-header__buttons-wrapper" }
const _hoisted_4 = { class: "qin-sub-header__icon qin-sub-header__icon--rotated" }
const _hoisted_5 = { class: "qin-sub-header__icon qin-sub-header__icon--white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_arrow_right = _resolveComponent("i-arrow-right")!
  const _component_i_logout = _resolveComponent("i-logout")!

  return ($setup.isSuperUser)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            class: "qin-sub-header__link ds-link hovered_underline",
            href: $setup.adminPanelUrl
          }, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_i_arrow_right)
            ]),
            _createElementVNode("span", null, _toDisplayString($setup.$t('To admin panel')), 1)
          ]),
          _createElementVNode("div", {
            class: "qin-sub-header__link ds-link hovered_underline",
            onClick: _withModifiers($setup.logout, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_i_logout)
            ]),
            _createElementVNode("span", null, _toDisplayString($setup.$t('Log Out')), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}